import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a125dfc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "RPPListItem" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = { class: "font-semibold" }
const _hoisted_5 = { class: "RPPListItem__content" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "flex w-full justify-end gap-2" }
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_change_company_modal = _resolveComponent("change-company-modal")!
  const _component_the_textarea = _resolveComponent("the-textarea")!
  const _component_modal = _resolveComponent("modal")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_button_dropdown = _resolveComponent("button-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_change)
      ? (_openBlock(), _createBlock(_component_change_company_modal, {
          key: 0,
          loading: _ctx.state.is_change_loading,
          onSubmit: _ctx.changeCompany,
          onCancel: _ctx.toggleChange
        }, null, 8, ["loading", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_submit)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 1,
          title: "Подтверждение РПП",
          loading: _ctx.state.is_submit_loading,
          onCancel: _ctx.toggleChangeStatus,
          onConfirm: _ctx.submitRpp
        }, {
          default: _withCtx(() => [
            _createVNode(_component_the_textarea, {
              disabled: _ctx.state.is_submit_loading,
              autoheight: "",
              rows: 4,
              placeholder: "Комментарий",
              value: _ctx.state.comment,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.comment) = $event))
            }, null, 8, ["disabled", "value"])
          ]),
          _: 1
        }, 8, ["loading", "onCancel", "onConfirm"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.item.status_id === 11)
          ? (_openBlock(), _createBlock(_component_checkbox, {
              key: 0,
              value: _ctx.isSelected,
              onChange: _ctx.onSelect
            }, null, 8, ["value", "onChange"]))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_4, [
          _createTextVNode(" Компания: " + _toDisplayString(_ctx.item.company_name) + " (", 1),
          _createVNode(_component_router_link, {
            class: "text-blue-500",
            to: `/rpp/${_ctx.item.id}`,
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _createTextVNode("ID: " + _toDisplayString(_ctx.item.id), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _createTextVNode(") ")
        ])
      ]),
      _createVNode(_component_cheap, { class: "small ml-4" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.item.status_name || 'Нет статуса'), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", null, "Дата РПП: " + _toDisplayString(_ctx.formatDate(_ctx.item.pbs_date)), 1),
      _createElementVNode("span", null, "Пользователь: " + _toDisplayString(_ctx.item.user_name || '-'), 1),
      _createElementVNode("span", null, "Номер АВР: " + _toDisplayString(_ctx.item.act_number || '-'), 1),
      _createElementVNode("span", null, "Дата АВР: " + _toDisplayString(_ctx.formatDateFromBackend(_ctx.item.act_date) || '-'), 1),
      _createElementVNode("span", null, "Дата создания заказа: " + _toDisplayString(_ctx.formatDate(_ctx.item.order_created_at)), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.getCostPriceTitle) + " " + _toDisplayString(_ctx.item.cost_price || '-'), 1),
      _createElementVNode("span", null, [
        _createTextVNode(" Номер FTL-заказа: "),
        (_ctx.item.ftl_order_id)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: `/ftl-orders/${_ctx.item.ftl_order_id}`,
              target: "_blank",
              class: "RPPListItem__link"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.item.ftl_order_id), 1)
              ]),
              _: 1
            }, 8, ["to"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.item.ftl_order_id || '-'), 1))
      ]),
      _createElementVNode("span", null, "Кем одобрено: " + _toDisplayString(_ctx.item.approver?.name || '-'), 1),
      _createElementVNode("span", null, "Дата оборота: " + _toDisplayString(_ctx.formatDate(_ctx.item.turnover_date)), 1)
    ]),
    _createElementVNode("p", null, "Направление (полное): " + _toDisplayString(_ctx.getFullPath()), 1),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.item.status_id === 13)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: `/rpp/edit/${_ctx.item.id}`,
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_button, { class: "text small primary" }, {
                default: _withCtx(() => [
                  _createTextVNode(" Редактировать ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
      (_ctx.isOnInspectionHeadTransportStatus && _ctx.state.is_head_of_transport_department)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_the_button, {
              class: "primary text small",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleChangeStatus('confirmed')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Подтвердить ")
              ]),
              _: 1
            }),
            _createVNode(_component_the_button, {
              class: "primary red text small ml-2",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleChangeStatus('denied')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Отказать ")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_button_dropdown, {
        title: "Выберите действие",
        placement: "bottom",
        "allowed-placements": ['bottom', 'top']
      }, {
        default: _withCtx(() => [
          (_ctx.item.ftl_order_id)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: `/ftl-orders/${_ctx.item.ftl_order_id}`,
                class: "mr-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_the_button, { class: "text small primary" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Открыть FTL заказ ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, {
            to: `/rpp/${_ctx.item.id}`,
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_button, { class: "text small primary" }, {
                default: _withCtx(() => [
                  _createTextVNode(" Подробнее ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode(_component_the_button, {
            class: "text small primary",
            onClick: _ctx.toggleChange
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Изменить компанию ")
            ]),
            _: 1
          }, 8, ["onClick"]),
          (_ctx.item.status_id === 11)
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 1,
                class: "text small primary",
                onClick: _ctx.onConfirm
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Подтвердить ")
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.havePermissions(['payment_by_suppliers-delete', 'all-root-permission']))
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 2,
                loading: _ctx.state.is_deleting,
                class: "small text red",
                onClick: _ctx.onDelete
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Удалить ")
                ]),
                _: 1
              }, 8, ["loading", "onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}